import { useState } from "react";
import { useTranslation } from "react-i18next";

import style from "./CourseTypeSelect.module.css";

import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/ui/select/Select";

import Icon from "@/ui/icon/Icon";

function CourseTypeSelect({ selectedCourseType, setSelectedCourseType }) {
	const { t } = useTranslation();

	return (
		<Select
			value={selectedCourseType}
			onValueChange={setSelectedCourseType}
		>
			<SelectTrigger>
				<SelectValue placeholder={t("courses:typeSelect.placeholder")} />
			</SelectTrigger>
			<SelectContent>
				<SelectGroup>
					<SelectItem className={style.item} value="all">
						{t("courses:typeSelect.all")}
					</SelectItem>
					<SelectItem className={style.item} value="video">
						<span>{t("courses:typeSelect.video")}</span>
						<Icon icon="fa-chalkboard" />
					</SelectItem>
					<SelectItem className={style.item} value="audio">
						<span>{t("courses:typeSelect.audio")}</span>
						<Icon icon="fa-headphones" />
					</SelectItem>
				</SelectGroup>
			</SelectContent>
		</Select>
	);
}

export default CourseTypeSelect;
